<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form
        ref="ff"
        size="small"
        :inline="true"
        :model="queryParams"
        class="search-form"
      >
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable />
        </el-form-item>
        <el-form-item>
          <el-button-group size="small">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="primary" plain @click="resetForm">重置</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <!--表格-->
    <el-empty
      v-if="!datalist.Items || datalist.Items.length == 0"
      style="height: 100%"
    />
    <div class="wrap" v-else>
      <el-descriptions
        :column="1"
        v-for="(row, index) in datalist.Items"
        :key="index"
      >
        <template slot="title">
          <h1>{{ row.Purchaser }}</h1>
          <p class="describe">
            投标时间
            {{ $utils.common.parseTime(row.BidDate, "{y}年{m}月{d}日") }}
          </p>
        </template>
        <template slot="extra">
          <slot :data="row" />
        </template>
        <el-descriptions-item label="登记时间">{{
          row.CreateTime
        }}</el-descriptions-item>
        <el-descriptions-item label="报备单位"
          >{{ row.Proposer.Dept }} {{ row.Proposer.Name }}</el-descriptions-item
        >
        <el-descriptions-item label="报备金额">
          <label>￥{{ row.Price }}</label>
          <label v-if="row.MinPrice"> 最低￥{{ row.MinPrice }}</label>
        </el-descriptions-item>
        <el-descriptions-item label="报备时间">
          <label>{{ row.DueDays }}天</label>
          <label> 截止到{{ $utils.common.parseTime(row.DueDate) }}</label>
        </el-descriptions-item>
        <el-descriptions-item label="备注信息" v-if="row.Remarks">{{
          row.Remarks
        }}</el-descriptions-item>
        <el-descriptions-item label="审核情况">
          <p>{{ row.StateText }} {{ row.Audit.Opinion }}</p>
          <p class="describe">
            {{ row.Audit.Auditor }} {{ row.Audit.OperTime }}
          </p>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <!--分页-->
    <el-pagination
      slot="footer"
      background
      :page-size="datalist.PageSize"
      :current-page="datalist.PageIndex"
      :total="datalist.TotalCount"
      @current-change="onPager"
    />
  </full-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      datalist: [],
      queryParams: {},
    };
  },
  props: {
    state: { type: Number, default: null },
  },
  created() {
    this.resetForm();
  },
  methods: {
    // 查询参数
    onSearch() {
      this.queryParams.index = 1;
      this.loadData();
    },
    resetForm() {
      this.queryParams = { index: 1, size: 24 };
      this.loadData();
    },
    // 分页触发事件
    onPager(val) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.project.enroll
        .list({
          ...this.queryParams,
          state: this.state,
        })
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-gap: 16px;
}

:deep(.el-descriptions) {
  background: #fff;
  padding: 10px 20px;
  &__header {
    display: block;
    margin-bottom: 30px;
  }
  &__extra {
    height: 20px;
    text-align: right;
  }
  &__title {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    flex: 1;
    line-height: 2;
    h1 {
      margin-top: 10px;
      border-bottom: 1px solid #f56c6c;
    }
  }
  &-item__label {
    min-width: 64px !important;
  }
}
</style>
